import React from 'react';
import { VgsFieldProvider } from '../../context/VgsField';

export default function VaultFormPage({
  children,
  visible,
}: {
  children: React.ReactNode | React.ReactNode[];
  visible: boolean;
}) {
  return <VgsFieldProvider visible={visible}>{children}</VgsFieldProvider>;
}
